export enum JobType {
  REGULAR = 'REGULAR',
  DEMO = 'DEMO',
}
